import React, { useEffect, useRef } from 'react'

function Cobertores({ onBackgroundImageCheck }) {
    const sectionRef = useRef(null);
    useEffect(() => {
        const sectionElement = sectionRef.current;
        const style = window.getComputedStyle(sectionElement);
        const hasBackgroundImage = style.backgroundImage !== 'none';
        onBackgroundImageCheck(hasBackgroundImage);
    }, [onBackgroundImageCheck]);
    
    return (
        <>
            <div id="carouselcobertores" className="carousel slide w-100 carousel-fade" data-bs-ride="carousel">
                <div className='carousel-inner'>
                    <div className='carousel-item active'>
                        <div className="d-flex w-100 d-block col-12 col-md-5 position-relative" id="img2" ref={sectionRef}>
                            <div className="position-absolute w-100 h-100"></div>
                            
                            <div className="row align-self-center w-100 d-none d-md-flex" id='alineardescripcion'>
                                <div className="col-12 col-md-7 mt-3 mt-md-0">
                                    <h1 className="display-4 fw-bold text-white">Cobertores</h1>
                                    <p className="lead text-white" style={{ textShadow: '0 0 5px rgba(0,0,0,0.5)' }}>
                                        Los cobertores para piscinas son una solución práctica para proteger y mantener tu piscina en óptimas condiciones durante todo el año.
                                        Además de su función protectora, también brindan seguridad.<br></br> Al cubrir completamente la piscina, ayudan a prevenir accidentes,
                                        especialmente para hogares con niños pequeños o mascotas.
                                    </p>
                                </div>
                                <div className="col-md-5"></div>
                            </div>
                        </div>
                        
                        <div className="container d-block d-md-none mt-3 p-4 bg-light rounded shadow-sm">
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="text-dark fs-2 fw-bold mb-3">Cobertores</h1>
                                    <p className="text-dark fs-5">
                                        Los cobertores para piscinas son una solución práctica para proteger y mantener tu piscina en óptimas condiciones durante todo el año.
                                        Además de su función protectora, también brindan seguridad.<br></br> Al cubrir completamente la piscina, ayudan a prevenir accidentes,
                                        especialmente para hogares con niños pequeños o mascotas.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className='carousel-item'>
                        <div className="d-flex w-100 d-block col-12 col-md-5 position-relative" id="img2-1" ref={sectionRef}>
                            <div className="position-absolute w-100 h-100"></div>
                            <div className="row align-self-center w-100 d-none d-md-flex" id='alineardescripcion'>
                                <div className="col-12 col-md-7 mt-3 mt-md-0">
                                    <h1 className="display-4 fw-bold text-white">Cobertores</h1>
                                    <p className="lead text-white" style={{ textShadow: '0 0 5px rgba(0,0,0,0.5)' }}>
                                        Los cobertores para piscinas son una solución práctica para proteger y mantener tu piscina en óptimas condiciones durante todo el año.
                                        Además de su función protectora, también brindan seguridad.<br></br> Al cubrir completamente la piscina, ayudan a prevenir accidentes,
                                        especialmente para hogares con niños pequeños o mascotas.
                                    </p>
                                </div>
                                <div className="col-md-5"></div>
                            </div>
                        </div>
                        
                        <div className="container d-block d-md-none mt-3 p-4 bg-light rounded shadow-sm">
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="text-dark fs-2 fw-bold mb-3">Cobertores</h1>
                                    <p className="text-dark fs-5">
                                        Los cobertores para piscinas son una solución práctica para proteger y mantener tu piscina en óptimas condiciones durante todo el año.
                                        Además de su función protectora, también brindan seguridad.<br></br> Al cubrir completamente la piscina, ayudan a prevenir accidentes,
                                        especialmente para hogares con niños pequeños o mascotas.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselcobertores" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselcobertores" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>

            <div id="carouselExampleControls" className="carousel slide w-100 carousel-fade" data-bs-ride="carousel">
                <div className='carousel-inner'>
                    <div className='carousel-item active'>
                        <div className="d-flex w-100 d-block col-12 col-md-5 position-relative" id="img3-1" ref={sectionRef}>
                            <div className="position-absolute w-100 h-100"></div>
                            <div className="row align-self-center w-100 d-none d-md-flex" id='alineardescripcion'>
                                <div className="col-12 col-md-7">
                                    <h1 className="display-4 fw-bold text-white">Cercamientos</h1>
                                    <p className="lead text-white" style={{ textShadow: '0 0 5px rgba(0,0,0,0.5)' }}>
                                        Descubre nuestra solución de cercamientos para piscinas.
                                        Con nuestro sistema de seguridad, podrás proteger tu piscina de manera efectiva y brindar tranquilidad a tu familia.
                                        Nuestros cercos son duraderos, de fácil instalación y cumplen con los estándares de seguridad más exigentes. <br />
                                        ¡Disfruta de tu piscina con total paz mental gracias a nuestros cercos perimetrales!
                                    </p>
                                </div>
                                <div className="col-md-5"></div>
                            </div>
                        </div>
                        
                        <div className="container d-block d-md-none mt-3 p-4 bg-light rounded shadow-sm">
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="text-dark fs-2 fw-bold mb-3">Cercamientos</h1>
                                    <p className="text-dark fs-5">
                                        Descubre nuestra solución de cercamientos para piscinas.
                                        Con nuestro sistema de seguridad, podrás proteger tu piscina de manera efectiva y brindar tranquilidad a tu familia.
                                        Nuestros cercos son duraderos, de fácil instalación y cumplen con los estándares de seguridad más exigentes. <br />
                                        ¡Disfruta de tu piscina con total paz mental gracias a nuestros cercos perimetrales!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className='carousel-item'>
                        <div className="d-flex w-100 d-block col-12 col-md-5 position-relative" id="img3" ref={sectionRef}>
                            <div className="position-absolute w-100 h-100"></div>
                            <div className="row align-self-center w-100 d-none d-md-flex" id='alineardescripcion'>
                                <div className="col-12 col-md-7">
                                    <h1 className="display-4 fw-bold text-white">Cercamientos</h1>
                                    <p className="lead text-white" style={{ textShadow: '0 0 5px rgba(0,0,0,0.5)' }}>
                                        Descubre nuestra solución de cercamientos para piscinas.
                                        Con nuestro sistema de seguridad, podrás proteger tu piscina de manera efectiva y brindar tranquilidad a tu familia.
                                        Nuestros cercos son duraderos, de fácil instalación y cumplen con los estándares de seguridad más exigentes. <br />
                                        ¡Disfruta de tu piscina con total paz mental gracias a nuestros cercos perimetrales!
                                    </p>
                                </div>
                                <div className="col-md-5"></div>
                            </div>
                        </div>
                        
                        <div className="container d-block d-md-none mt-3 p-4 bg-light rounded shadow-sm">
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="text-dark fs-2 fw-bold mb-3">Cercamientos</h1>
                                    <p className="text-dark fs-5">
                                        Descubre nuestra solución de cercamientos para piscinas.
                                        Con nuestro sistema de seguridad, podrás proteger tu piscina de manera efectiva y brindar tranquilidad a tu familia.
                                        Nuestros cercos son duraderos, de fácil instalación y cumplen con los estándares de seguridad más exigentes. <br />
                                        ¡Disfruta de tu piscina con total paz mental gracias a nuestros cercos perimetrales!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </>
    )
}

export default Cobertores